import { Button } from "components"
import { TabTransaction , TabProps } from "../types"

export function TabNavTransaction({ activeTab, setActiveTab , disablePath}: TabProps) {

  const tabs: TabTransaction[] = [
    { label: "PROFILE", path: "profile", permission: "SUBSCRIBED" },
    { label: "BOQ", path: "boq", permission: "SUBSCRIBED" },
    { label: "CHECKLIST", path: "checklist", permission: "SUBSCRIBED" },
    { label: "TASK", path: "task", permission: "SUBSCRIBED" },
    { label: "TRANSACTION", path: "transaction", permission: "SUBSCRIBED" },
    { label: "RESOURCES", path: "resources", permission: "SUBSCRIBED" },
    { label: "ADDRESS", path: "address", permission: "SUBSCRIBED" },
    { label: "E-MEDIA", path: "emedia", permission: "SUBSCRIBED" },
    { label: "DASHBOARD", path: "dashboard", permission: "SUBSCRIBED" },
  ]

  return (
    <section className="grow flex items-stretch overflow-x-auto sticky top-[60px] z-[1]">
      {tabs.map((tab) => (
        <Button
          key={tab.path}
          permission={tab?.permission}
          type="button"
          color="ghost"
          size="sm"
          disabled={disablePath?.includes(tab.path) ?? false}
          className={`mr-0.5 grow bg-[#3c3c3c] border-y-0 border-x no-animation hover:bg-primary hover:text-black whitespace-nowrap uppercase ${tab.path === activeTab ? "bg-primary text-black" : "text-white"}`}
          onClick={() => setActiveTab(tab.path)}
        >
          {tab.label}
        </Button>
      ))}
    </section>
  )
}
